@switch (context ? context.type : '') {
    @default {
        <fui-edit-time-input [control]="control" [disabled]="disabled" #input [label]="label"
                             (focussed$)="onFocussed($event)" [(ngModel)]="value"></fui-edit-time-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-time-input [disabled]="disabled" #input [(ngModel)]="value" (focussed$)="onFocussed($event)"
                               [label]="label"></fui-filter-time-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-time-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                               (focussed$)="onFocussed($event)"></fui-inline-time-input>
    }
    @case (contextType.PILL) {
        <fui-pill-time-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                             (focussed$)="onFocussed($event)"></fui-pill-time-input>
    }
}
